<template>
<div class="page-footer d-flex align-items-center">
  <div class="container">
    <div class="row justify-content-between text-center py-3">
      <div v-for="(item, key, index) in data" :key="index" class="col-12 col-lg-auto mb-2 py-2">
        <p class="text" v-html="item"></p>
      </div>
      <div class="col-12 col-lg-auto mb-2 py-2">
        <p class="text">
          <router-link :to="'/disclaimer'" class="page-footer__link">Disclaimer</router-link>
        </p>
      </div>
      <div class="col-12 col-lg-auto mb-2 py-2">
        <p class="text">
          <router-link :to="'/impressum'" class="page-footer__link">Impressum</router-link>
        </p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: ['data']
}
</script>

<style lang="scss">
.page-footer {
  width: 100%;
  height: auto;
  background-color: $white;

  @media (min-width: 992px) {
    min-height: 10rem;
  }

  &__link {
    color: $gray;
    text-decoration: none;

    &:hover {
      cursor: pointer;
    }
  }
}


</style>